var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty c:col-center"},[_c('img',{attrs:{"src":require("@/assets/icons/empty.svg"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }